module.exports = __webpack_public_path__ + "media/images/block-wait-2x-abae0296.png";